import React from 'react';
import { Container, Row, Col, Button, NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';
import { serverUrl } from 'Config';
import axios from 'axios';
import Footer from '@components/Footer';

class Disclaimer extends React.Component {
    constructor(props) {
        super(props);

        this.onAgree = this.onAgree.bind(this);
    }

    onAgree() {
        axios({
            method: 'GET',
            url: serverUrl + '/disclaimer'
        }).then(resp => {
        });
    }

    render() {
        return (
            <div className="simple-page">
                <header className="app-header navbar">
                    <Container className="fluid">
                        <div className="fp-top">
                            <Row>
                                <Col><NavbarBrand href="https://www.corlytics.com"></NavbarBrand></Col>
                            </Row>
                        </div>
                    </Container>
                </header>
                <Container>
                    <Row>
                        <Col>
                            <div className="card">
                                <div className="card-header">Disclaimer</div>
                                <div className="card-block">
                                    <Row className="mb-4">
                                        <Col>
                                            <p>We will not disclose your personal information to third parties outside of this agreement. Your personal information (name, e-mail address, password, IP address at the time of log in and session duration) will be processed to enable access to the system. You have rights in relation to this data including, a right of access, a right to be informed and a right to object. Further information is available in our Privacy Policy at <a href="http://www.corlytics.com/privacy/" target="_blank">http://www.corlytics.com/privacy/</a> . If you have any queries in relation to privacy, please contact us at <a href="mailto:privacy@corlytics.com">privacy@corlytics.com</a>.</p>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <Row className="mt-2">
                                        <Col>
                                            <Link to={'/login'}>
                                                <button className="btn btn-secondary-new">Cancel</button>                        
                                            </Link>
                                        </Col>
                                        <Col className="text-right">
                                            <button className="btn btn-primary-new" onClick={this.onAgree}>I agree</button>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
                <Footer />       
            </div>
        )
    }
}
 
export default Disclaimer;


// WEBPACK FOOTER //
// ./src/views/Pages/Disclaimer/Disclaimer.js